export const TSEquals = (key: string, comparison: string | string[] | boolean | number[]) => {
  if (comparison instanceof Array) {
    if (comparison.length === 0) {
      return null;
    }
    return `${key}: [${comparison.join(', ')}]`;
  }
  if (comparison === undefined || comparison === null) return null;
  return `${key}: ${comparison}`;
};

export const TSList = (op: 'and' | 'or', conditions: (string | null)[]) => {
  const filter = conditions.filter(Boolean);
  if (filter.length === 0) return null;
  return '(' + filter.join(op === 'and' ? ' && ' : ' || ') + ')';
};
